module.exports = __webpack_public_path__ + "img/ico-16.882a8810.svg";